export default __webpack_public_path__ + "static/media/twitter.18d83b39.png";